module.exports = __webpack_public_path__ + "img/Bci-Peru.908b6af5.svg";